import React from "react";
import { Outlet } from "react-router-dom";

const SupportDoc = () => {
    return (
        <Outlet />
    )
};

export default SupportDoc;